import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const SubdivisionsFilter = ({
    subdivisions = [],
    loading = false,
    filters,
    restoreFilterValues,
    hidden = false,
    onChangeValue,
}) => (
    <Field
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        hidden={hidden}
        multiple
        name='countrySubdivisions'
        options={subdivisions}
        placeholder='Subdivision'
        search
        selection
        setValue={restoreFilterValues(filters, 'countrySubdivisions')}
        onChangeValue={onChangeValue}
    />
);

SubdivisionsFilter.propTypes = {
    subdivisions: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    hidden: PropTypes.bool,
    onChangeValue: PropTypes.func,
};
